import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReporteHistoricoComponent } from '../../../../../reportes/reporte-historico/reporte-historico.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ReporteCombustibleHistorico } from '../../../../../../_entities/vehiculos/ReporteCombustibleHistorico';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { MapaService } from '../../../../services/mapa.service';

@Component({
  selector: 'kt-grafica-historico-combustible',
  templateUrl: './grafica-historico-combustible.component.html',
  styleUrls: ['./grafica-historico-combustible.component.scss']
})
export class GraficaHistoricoCombustibleComponent implements OnInit {
	datos:ReporteCombustibleHistorico[];
	datosN: ReporteCombustibleHistorico[];
	colorScheme = {
		domain: ['#166BA2']
	};	
	public loadingVisible: boolean = false;
	public legend: boolean = true;
	public showLabels: boolean = true;
	public animations: boolean = true;
	public xAxis: boolean = true;
	public yAxis: boolean = true;
	public showYAxisLabel: boolean = true;
	public showXAxisLabel: boolean = true;
	public timeline: boolean = true;
	public showGrafica = false;
	public vehiculo;

	constructor(
		private datepipe: DatePipe,
		private toastService: ToastrService,
		public dialogRef: MatDialogRef<GraficaHistoricoCombustibleComponent>,
		@Inject(MAT_DIALOG_DATA) public data:any,
		private mapaService:MapaService
	) { }

	ngOnInit(): void {
		console.log(this.data,"DATA")
		this.datos = this.data.datos;
		this.vehiculo = this.data.info.descripcion
		// this.datos.sort(function (a, b) {
		//  	if (b.fecha < a.fecha)
		//   		return -1;
		//   	else if (a.fecha > b.fecha)
		//   		return +1;
		//   	else 
		//   		return 0;
		// });
		
	}

	customizeText(arg: any) {
		return `${arg.valueText} L`;
	}

  	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

		/**Obtener Reporte Velocidad */

		validarInfo(valor) {
			let value = 'Sin Datos';
	
			if (valor) {
				value = valor
			}
	
			return value;
		}

		imprimirPdf() {
			this.loadingVisible = true;
			var grafica = document.getElementById('grafica')
			const PLACA = this.validarInfo(this.data.info.placas);
			const ECONOMICO = this.validarInfo(this.data.info.economico);
			const SERIE = this.validarInfo(this.data.info.numeroSerie)
			const MARCA = this.validarInfo(this.data.info.marca);
			const MODELO = this.validarInfo(this.data.infomodelo);
			const ANIO = this.validarInfo(this.data.infoanio);
			const COLOR = this.validarInfo(this.data.infocolor);
			const DESCRIPCION = this.validarInfo(this.data.infodescripcion);
			let fechaHora = this.data.info.fechaHoraUltimaPosicion;
	
			const FECHA_INICIAL = this.datepipe.transform(this.data.fechaInicio, 'dd/MM/yyyy h:MM a');
		 const FECHA_FINAL = this.datepipe.transform(this.data.fechaFinal, 'dd/MM/yyyy h:MM a');
	
			fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');
			let direccion;
	
			this.mapaService.getDireccion([this.data.info.lat, this.data.info.lng]).then(
				(data: any) => {
					direccion = data.display_name || "Dirección Desconocida";
				},
				() => {
					direccion = "Dirección Desconocida";
				}
			);
	
			setTimeout(async () => {
				await html2canvas(grafica).then(
					(canvas) => {
						const graficaImagen = canvas.toDataURL('image/png');
	
						var pdf = new jsPDF('p', 'pt', 'a4');
	
						const logoGTM = './assets/media/logos/logo-gtm.png'
						const logoGTMX = 20;
						const logoGTMY = 15;
						const logoGTMWidth = 180;
						const logoGTMHeight = 80;
						pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');
	
						const logoGTMWater = './assets/media/logos/marca-de-agua.png'
						const logoGTMWaterX = 15;
						const logoGTMWaterY = 130;
						const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
						const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
						const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
						pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');
	
						pdf.setFontSize(18);
						pdf.setFont('', 'bold')
						pdf.text('Historial de Combustible', 215, 120);
						pdf.text('Inicio: ' + FECHA_INICIAL + ' - Fin: ' + FECHA_FINAL, 90, 145)
	
						const PROPERTIES = (pdf as any).getImageProperties(graficaImagen);
						const WIDTH = pdf.internal.pageSize.getWidth() - 2 * 15;
						const HEIGHT = (PROPERTIES.height * WIDTH) / PROPERTIES.width;
						pdf.addImage(graficaImagen, 'PNG', 15, 170, WIDTH, 250);
	
						pdf.setFontSize(14);
						pdf.setFont('', 'bold')
						pdf.text('Datos del Dispositivo', 90, 470,);
	
						pdf.setFont('', 'normal')
						pdf.text('Vehículo:', 90, 485);
						pdf.text(MARCA + ', ' + MODELO, 340, 485);
	
						pdf.text('Placa:', 90, 500);
						pdf.text(PLACA, 340, 500);
	
						pdf.text('Económico:', 90, 515);
						pdf.text(ECONOMICO, 340, 515);
	
						pdf.text('Número de Serie:', 90, 530);
						pdf.text(SERIE, 340, 530);
	
						pdf.text('Año:', 90, 545);
						pdf.text(ANIO + '', 340, 545);
	
						pdf.text('Color:', 90, 560);
						pdf.text(COLOR, 340, 560);
	
						pdf.text('Descripción:', 90, 575);
						pdf.text(DESCRIPCION, 340, 575);
	
						pdf.text('Dirección:', 90, 590);
						pdf.text(direccion + '', 340, 590);
	
						pdf.setFontSize(12);
						pdf.setFont('', 'bold')
						pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
						pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
						pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, soporte.star@growtec.com.mx', 65, 825);
	
						const nombreArchivo = 'Historial_Combustible';
						pdf.save(nombreArchivo + '.pdf');
						this.loadingVisible = false;
	
					}
				)
			}, 1)
		}	
}
